import React from 'react'
import styled from 'styled-components'
import jQuery from "jquery";
import { Link } from 'gatsby'
import sliderCSS from '../styles/slider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const handleScriptLoad = () => {
  if(typeof document !== 'undefined') {
    let s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "/js/jquery.themepunch.tools.min.js";
    document.body.appendChild(s);

    s = document.createElement("script");
    s.type = "text/javascript";
    s.src = "/js/jquery.themepunch.revolution.min.js";
    document.body.appendChild(s);
  }
};

const waitForEl = function(selector, method, callback) {
  let timeout = null;
  if (!method && jQuery(selector).length) {
    clearTimeout(timeout);
    callback();
  }
  else if (method && typeof jQuery(selector)[method] !== 'undefined') {
    clearTimeout(timeout);
    callback();
  } else {
    timeout = setTimeout(function () {
      waitForEl(selector, method, callback);
    }, 5);
  }
};

const waitForGlobal = function(globalName, callback) {
  let timeout = null;
  if (window[globalName] !== undefined) {
    clearTimeout(timeout);
    callback();
  }
  else {
    timeout = setTimeout(function () {
      waitForGlobal(globalName, callback);
    }, 5);
  }
};

class Slider extends React.Component {
  constructor(props) {
    super(props)
    handleScriptLoad();
    initSlider();
  }

  handleSlideClick(slide) {
    if (this.hasLink(slide)) {
      let link = null;
      if (slide.link.path) {
        link = slide.link.path;
      } else if (slide.link.url) {
        link = slide.link.url;
      } else if (slide.link.pageLinks) {
        link = '/' + slide.link.pageLinks[0].slug
      }
      if (link) {
        window.location = link;
      }
    }
  }

  hasLink(slide) {
    return slide.link;
  }

  render() {
    const { data } = this.props;
    if (!data) return null

    return <>
      <style dangerouslySetInnerHTML={{ __html: sliderCSS }}/>
      <FlatSliderContainer>
        <BannerContainer>
          <div className="tp-banner" style={{ visibility: 'hidden' }}>
            <ul>
              {data.slides && data.slides.map((slide, index) => {
                return (
                  <li style={this.hasLink(slide) ? {cursor: 'pointer'} : {}} onClick={() => this.handleSlideClick(slide)} key={'slide_'+index} data-transition="random-static" data-slotamount="7" data-masterspeed="1000" data-saveperformance="on">
                    <img src={slide.image.fluid.src} alt={slide.image.description}/>
                    <div className={`tp-caption sfl title-slide ${slide.slug === 'slide-two' && 'title-big-slide'} style6 bambooAsiaHeadline start`} data-x="0" data-y="120" data-speed="1500" data-start="1500" data-easing="Sine.easeInOut" dangerouslySetInnerHTML={{ __html: slide.headline }} />
                    <div className="tp-caption sfr description-slider style1 center bambooAsiaSubHeadline start" data-x="0" data-y="550" data-speed="2000" data-start="1500" data-easing="Power3.easeInOut" dangerouslySetInnerHTML={{ __html: slide.subHeadline }} />
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="flat-vertical social-links">
            <a href="https://www.instagram.com/bambooasia/" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={['fab', 'instagram']} size="lg" />
            </a>
            <span style={{textTransform: 'uppercase'}}>Follow us</span>
          </div>
          <div className="flat-vertical reservation">
            <Link to={'/order-online'} style={{textTransform: 'uppercase'}}>
              Order online
            </Link>
          </div>
        </BannerContainer>
      </FlatSliderContainer>
    </>
  }
}

const initSlider = () => {
  if (typeof window !== 'undefined') {
    const $ = window.$ = window.jQuery = window.jquery = jQuery;

    $(document).ready(function() {
      waitForEl('.tp-banner', 'revolution', function() {
        // sometimes the revolution tools global `punchgs` is not loaded in time
        waitForGlobal('punchgs', function() {
          $('.tp-banner').css('visibility', 'visible').revolution({
            dottedOverlay: "none",
            delay: 6000,
            startwidth: 1170,
            startheight: 853,
            hideThumbs: true,

            thumbWidth: 100,
            thumbHeight: 50,
            thumbAmount: 5,

            touchenabled: "on",
            onHoverStop: "on",

            swipe_velocity: 0.7,
            swipe_min_touches: 1,
            swipe_max_touches: 1,
            drag_block_vertical: false,

            parallax: "mouse",
            parallaxBgFreeze: "on",
            parallaxLevels: [7, 4, 3, 2, 5, 4, 3, 2, 1, 0],

            keyboardNavigation: "off",

            navigationHAlign: "center",
            navigationVAlign: "bottom",
            navigationHOffset: 0,
            navigationVOffset: 20,

            soloArrowLeftHalign: "left",
            soloArrowLeftValign: "center",
            soloArrowLeftHOffset: 20,
            soloArrowLeftVOffset: 0,

            soloArrowRightHalign: "right",
            soloArrowRightValign: "center",
            soloArrowRightHOffset: 20,
            soloArrowRightVOffset: 0,

            shadow: 0,
            fullWidth: "on",
            fullScreen: "off",

            spinner: "spinner4",

            stopLoop: "off",
            stopAfterLoops: -1,
            stopAtSlide: -1,

            shuffle: "off",

            autoHeight: "off",
            forceFullWidth: "off",

            hideThumbsOnMobile: "off",
            hideNavDelayOnMobile: 1500,
            hideBulletsOnMobile: "off",
            hideArrowsOnMobile: "off",
            hideThumbsUnderResolution: 0,

            hideSliderAtLimit: 0,
            hideCaptionAtLimit: 0,
            hideAllCaptionAtLilmit: 0,
            startWithSlide: 0,
            fullScreenOffsetContainer: "",

            disableProgressBar: "on"
          });
        })
      })
    })
  }
};

const FlatSliderContainer = styled.div`
	position: relative;
	width: 100%;
	margin-bottom: 2rem;
`

const BannerContainer = styled.div`
	max-height: 853px !important;
	width: 100% !important;
	position: relative;
	padding: 0;
  background-color: #fff;
  
  .tp-caption.bambooAsiaHeadline {
    font-family: 'BrownProBold', sans-serif;
    // font-size: 7em !important;
    font-weight: 700;
    line-height: 0.859em !important;
    letter-spacing: -0.07em !important;
    color: white;
    text-transform: lowercase;
  }

  .tp-caption.bambooAsiaSubHeadline {
    font-family: "BrownProRegular", arial, sans-serif;
    letter-spacing: 0.107em !important;
    line-height: 1.429em !important;
    color: white;
    font-weight: 400;
    text-transform: uppercase;
    display: block;
  }
  .tp-caption.bambooAsiaHeadline.title-big-slide {
      font-size: 10em;
      line-height: 112px;
  }

  .slider-button {
    position: absolute;
    top: 50%;
    z-index: 999;
    opacity: 0;
    background: rgba(255,255,255,0.9);
    width: 4em;
    height: 4em;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: none;
    transition: opacity 0.5s ease-in;
  }
  #slide-next {
    right: 1em;
  }
  #slide-prev {
    left: 1em;
  }
  &:hover .slider-button {
    opacity: 1;
  }

  #slider-counter a {
    font-size: 12px;
    color: #000000;
    font-family: 'BrownProRegular', sans-serif;
    font-weight: 400;
  }

  #slider-counter a.active {
    color: #ffffff;
    position: relative;
  }

  #slider-counter a.active:before {
    content: "";
    position: absolute;
    width: 49px;
    height: 2px;
    background-color: #ffffff;
    top: 50px;
    right: -7px;
    transform: rotate(-90deg) !important;
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    transform-origin: 0 50%;
    -webkit-transform-origin: 0 50%;
    -o-transform-origin: 0 50%;
    -ms-transform-origin: 0 50%;
    -moz-transform-origin: 0 50%;
  }
`

export default Slider
